import React from "react";
import ArrowCircleRight from "../../../assets/ArrowCircleRight.svg";
import { useNavigate } from "react-router-dom";

export const AssessmentCard = ({ icon, title, subtitle, imgSrc, link }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(link);
  };
  return (
    
      <div className="blog-post-card1">
        <img className="assessment-img" src={imgSrc} alt="Assessment" />
        <div className="content-ass">
          <div className="heading-and-subheading">
            <div className="heading-and-text">
              <div className="blog-content-post">
                <div className="heading-icon">
                  <p className="heading-text">{icon} {title}</p>
                  <div className="icon-wrap"></div>
                </div>
                <p className="heading-subtitle">{subtitle}</p>
              </div>
            </div>
          </div>
        </div>
              <button className="btn-start-refection" onClick={handleClick}>
                <span className="btn-text">Start Reflection</span>
                <img className="arrow" src={ArrowCircleRight} alt="Arrow" />
              </button>
      </div>
    
  );
};


